import { Component, inject } from '@angular/core';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';

@Component({
    selector: 'app-general-dialog',
    templateUrl: './general-dialog.component.html',
    styleUrls: ['./general-dialog.component.css'],
    standalone: false,
})
export class GeneralDialogComponent {
    private readonly dialogRef = inject<BrnDialogRef>(BrnDialogRef);
    private readonly dialogContext = injectBrnDialogContext<{ title: string; message: string }>();

    protected readonly title = this.dialogContext.title;
    protected readonly message = this.dialogContext.message;

    public close(): void {
        this.dialogRef.close();
    }
}
